import { createProvider } from '@nvision/services/data-provider';
import { queryOptions } from '@tanstack/react-query';

import { CACHE_KEYS } from '../../types';
import * as api from './api';
import { normalizeLookupCodeOptions } from './normalize';

export const lookupCodesQueryOptions = (lookupCodeType: string, keys?: number[], enabled = true) =>
  queryOptions({
    enabled,
    queryFn: () => fetchLookupCodesList(lookupCodeType, keys),
    queryKey: [...CACHE_KEYS.lookupCodes(), lookupCodeType, keys],
    staleTime: Number.POSITIVE_INFINITY,
  });

export const fetchLookupCodesList = createProvider(api.fetchLookupCodesList)
  .andThen((res) => normalizeLookupCodeOptions(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch lookup code list aborted');
    } else {
      console.error('Fetch lookup code list was failed:', error);
    }
    throw error;
  });
